import { render, staticRenderFns } from "./SelectGenome.vue?vue&type=template&id=3321d0b2"
import script from "./SelectGenome.vue?vue&type=script&lang=ts"
export * from "./SelectGenome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports